import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const deliverables = [
  {
    icon: 'ri-alert-line',
    title: 'Produtos com risco de ruptura',
    description:
      'Os itens com maior chance de faltar nos próximos dias, com os dias de cobertura estimados.',
  },
  {
    icon: 'ri-checkbox-circle-line',
    title: 'Produtos em excesso',
    description:
      'O que está sobrando no estoque, com a estimativa de capital imobilizado em cada item.',
  },
  {
    icon: 'ri-file-excel-2-line',
    title: 'Sugestão de compra por produto',
    description:
      'A quantidade sugerida de compra de cada produto, exportável em planilha.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Comparação com o método atual',
    description:
      'O erro de previsão da abordagem sugerida comparado ao método que a empresa usa hoje.',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Relatório de qualidade dos dados',
    description:
      'Avaliação dos dados enviados: o que está consistente, o que falta e o que precisa ser corrigido.',
  },
];

export default function DeliverablesSection() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section id="entregaveis" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6" ref={ref}>
        <div className="text-center mb-14">
          <span className="inline-block font-sora font-semibold text-emerald-600 text-sm uppercase tracking-widest mb-3">
            O que você recebe
          </span>
          <h2 className="font-sora font-bold text-3xl md:text-4xl text-zinc-900 mb-4">
            Um relatório pronto para a decisão
          </h2>
          <p className="font-inter text-zinc-500 max-w-xl mx-auto text-base">
            Não é um painel para você aprender a usar. É um diagnóstico fechado, com
            entregáveis concretos e objetivos.
          </p>
          <div className="w-12 h-1 bg-emerald-500 rounded-full mx-auto mt-5" />
        </div>

        <ul
          className={`grid grid-cols-1 lg:grid-cols-2 gap-6 transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {deliverables.map((item, index) => (
            <li
              key={item.title}
              className={`bg-white rounded-2xl border border-zinc-100 p-6 md:p-8 flex gap-5 ${
                index === deliverables.length - 1 ? 'lg:col-span-2' : ''
              }`}
            >
              <div
                className="w-12 h-12 shrink-0 flex items-center justify-center rounded-xl bg-emerald-500/10 border border-emerald-500/20"
                aria-hidden="true"
              >
                <i className={`${item.icon} text-emerald-600 text-xl`} />
              </div>
              <div>
                <h3 className="font-sora font-semibold text-base text-zinc-900 mb-2">
                  {item.title}
                </h3>
                <p className="font-inter text-zinc-500 text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
